import { render, staticRenderFns } from "./dialog-approve-xufuzongshenpi.vue?vue&type=template&id=1d2f5ed8&scoped=true&"
import script from "./dialog-approve-xufuzongshenpi.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-xufuzongshenpi.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-xufuzongshenpi.vue?vue&type=style&index=0&id=1d2f5ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f5ed8",
  null
  
)

export default component.exports